export const yodaOrdersConstants = {
  LOADING: "YODAORDERS_LOADING",
  GETALL_HEADER_REQUEST: "YODAORDERS_GETALL_HEADER_REQUEST",
  GETALL_HEADER_SUCCESS: "YODAORDERS_GETALL_HEADER_SUCCESS",
  GETALL_HEADER_FAILURE: "YODAORDERS_GETALL_HEADER_FAILURE",

  GETALL_REQUEST: "_GETALL_REQUEST",
  GETALL_SUCCESS: "YODAORDERS_GETALL_SUCCESS",
  GETALL_FAILURE: "YODAORDERS_GETALL_FAILURE",

  GETONE_REQUEST: "YODAORDERS_GETONE_REQUEST",
  GETONE_SUCCESS: "YODAORDERS_GETONE_SUCCESS",
  GETONE_FAILURE: "YODAORDERS_GETONE_FAILURE",

  GET_DETAILS_REQUEST: "YODAORDERS_GET_DETAILS_REQUEST",
  GET_DETAILS_SUCCESS: "YODAORDERS_GET_DETAILS_SUCCESS",
  GET_DETAILS_FAILURE: "YODAORDERS_GET_DETAILS_FAILURE",

  GET_SILENT_DETAILS_REQUEST: "YODAORDERS_GET_SILENT_DETAILS_REQUEST",
  GET_SILENT_DETAILS_SUCCESS: "YODAORDERS_GET_SILENT_DETAILS_SUCCESS",
  GET_SILENT_DETAILS_FAILURE: "YODAORDERS_GET_SILENT_DETAILS_FAILURE",
  GET_SILENT_DETAILS_REQUEST_FAILURE: "YODAORDERS_GET_SILENT_DETAILS_REQUEST",

  GET_ROW_DETAILS_REQUEST: "YODAORDERS_GET_ROW_DETAILS_REQUEST",
  GET_ROW_DETAILS_SUCCESS: "YODAORDERS_GET_ROW_DETAILS_SUCCESS",
  GET_ROW_DETAILS_FAILURE: "YODAORDERS_GET_ROW_DETAILS_FAILURE",
  GET_ROW_DETAILS_RESET: "GET_ROW_DETAILS_RESET",

  CREATE_HEADER_REQUEST: "YODAORDERS_CREATE_HEADER_REQUEST",
  CREATE_HEADER_SUCCESS: "YODAORDERS_CREATE_HEADER_SUCCESS",
  CREATE_HEADER_FAILURE: "YODAORDERS_CREATE_HEADER_FAILURE",

  CONCURRENT_UPDATE_ROW_SINGLE_REQUEST:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_SINGLE_REQUEST",
  CONCURRENT_UPDATE_ROW_SINGLE_SUCCESS:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_SINGLE_SUCCESS",
  CONCURRENT_UPDATE_ROW_SINGLE_REQUEST_END:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_SINGLE_REQUEST_END",
  CONCURRENT_UPDATE_ROW_SINGLE_FAILURE:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_SINGLE_FAILURE",

  CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST",
  CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_SUCCESS:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_SUCCESS",
  CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST_END:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST_END",
  CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_FAILURE:
    "YODAORDERS_CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_FAILURE",

  CONCURRENT_UPDATE_ROW_SUCCESS_AUTOCANCELLED:
    "CONCURRENT_UPDATE_ROW_SUCCESS_AUTOCANCELLED",

  ADD_ROW_REQUEST: "YODAORDERS_ADD_ROW_REQUEST",
  ADD_ROW_SUCCESS: "YODAORDERS_ADD_ROW_SUCCESS",
  ADD_ROW_FAILURE: "YODAORDERS_ADD_ROW_FAILURE",

  UPDATE_ROW_REQUEST: "YODAORDERS_UPDATE_ROW_REQUEST",
  UPDATE_ROW_SUCCESS: "YODAORDERS_UPDATE_ROW_SUCCESS",
  UPDATE_ROW_FAILURE: "YODAORDERS_UPDATE_ROW_FAILURE",

  REMOVE_ROW_REQUEST: "YODAORDERS_REMOVE_ROW_REQUEST",
  REMOVE_ROW_SUCCESS: "YODAORDERS_REMOVE_ROW_SUCCESS",
  REMOVE_ROW_FAILURE: "YODAORDERS_REMOVE_ROW_FAILURE",

  CONFIRM_ORDER_REQUEST: "YODAORDERS_CONFIRM_ORDER_REQUEST",
  CONFIRM_ORDER_SUCCESS: "YODAORDERS_CONFIRM_ORDER_SUCCESS",
  CONFIRM_ORDER_FAILURE: "YODAORDERS_CONFIRM_ORDER_FAILURE",

  REMOVE_ORDER_REQUEST: "YODAORDERS_REMOVE_ORDER_REQUEST",
  REMOVE_ORDER_SUCCESS: "YODAORDERS_REMOVE_ORDER_SUCCESS",
  REMOVE_ORDER_FAILURE: "YODAORDERS_REMOVE_ORDER_FAILURE",

  CONFIGURATION_ORDER_REQUEST: "ORDER_CONFIGURATION_ORDER_REQUEST",
  CONFIGURATION_ORDER_SUCCESS: "ORDER_CONFIGURATION_ORDER_SUCCESS",
  CONFIGURATION_ORDER_FAILURE: "ORDER_CONFIGURATION_ORDER_FAILURE",

  SWITCH_TYPE_REQUEST: "ORDER_SWITCH_TYPE_REQUEST",
  SWITCH_TYPE_SUCCESS: "ORDER_SWITCH_TYPE_SUCCESS",
  SWITCH_TYPE_FAILURE: "ORDER_SWITCH_TYPE_FAILURE",

  ORDER_ID_RESET: "ORDER_ID_RESET",

  GETALL_ADMIN_DRAFT_REQUEST: "YODAORDERS_GETALL_ADMIN_DRAFT_REQUEST",
  GETALL_ADMIN_DRAFT_SUCCESS: "YODAORDERS_GETALL_ADMIN_DRAFT_SUCCESS",
  GETALL_ADMIN_DRAFT_FAILURE: "YODAORDERS_GETALL_ADMIN_DRAFT_FAILURE",

  WAITING_FOR_CONFIRMATION_REQUEST:
    "YODAORDERS_WAITING_FOR_CONFIRMATION_REQUEST",
  WAITING_FOR_CONFIRMATION_SUCCESS:
    "YODAORDERS_WAITING_FOR_CONFIRMATION_SUCCESS",
  WAITING_FOR_CONFIRMATION_FAILURE:
    "YODAORDERS_WAITING_FOR_CONFIRMATION_FAILURE",

  TRANSMIT_ORDER_REQUEST: "YODAORDERS_TRANSMIT_ORDER_REQUEST",
  TRANSMIT_ORDER_SUCCESS: "YODAORDERS_TRANSMIT_ORDER_SUCCESS",
  TRANSMIT_ORDER_FAILURE: "YODAORDERS_TRANSMIT_ORDER_FAILURE",

  RESET_ERROR: "YODAORDERS_RESET_ERROR",
  RESET_ORDER: "YODAORDERS_RESET_ORDER",

  REMOVE_PRODUCT_REQUEST: "YODAORDERS_REMOVE_PRODUCT_REQUEST",
  REMOVE_PRODUCT_SUCCESS: "YODAORDERS_REMOVE_PRODUCT_SUCCESS",
  REMOVE_PRODUCT_FAILURE: "YODAORDERS_REMOVE_PRODUCT_FAILURE",

  GENERATE_REPORT_REQUEST: "ORDER_GENERATE_REPORT_REQUEST",
  GENERATE_REPORT_SUCCESS: "ORDER_GENERATE_REPORT_SUCCESS",
  GENERATE_REPORT_FAILURE: "ORDER_GENERATE_REPORT_FAILURE",

  GET_ORDER_SHIPPING_COST_REQUEST: "YODAORDERS_GET_ORDER_SHIPPING_COST_REQUEST",
  GET_ORDER_SHIPPING_COST_SUCCESS: "YODAORDERS_GET_ORDER_SHIPPING_COST_SUCCESS",
  GET_ORDER_SHIPPING_COST_FAILURE: "YODAORDERS_GET_ORDER_SHIPPING_COST_FAILURE",

  GET_STATUS_ORDER_REQUEST: "YODAORDERS_GET_STATUS_ORDER_REQUEST",
  GET_STATUS_ORDER_REQUEST_SUCCESS:
    "YODAORDERS_GET_STATUS_ORDER_REQUEST_SUCCESS",
  GET_STATUS_ORDER_REQUEST_FAILURE:
    "YODAORDERS_GET_STATUS_ORDER_REQUEST_FAILURE",

  CHANGE_LANGUAGE: "YODAORDERS_CHANGE_LANGUAGE",
};
